/**
 * Поведение сайта mykairo.ru — без фреймворка: страницы должны открываться
 * мгновенно.
 *
 * - блоки с классом `reveal` выплывают, когда доходят до экрана;
 * - шапка получает тень, как только страница прокручена;
 * - мобильное меню открывается кнопкой;
 * - в подвале — текущий год.
 */

import './site.css';

function revealOnScroll(): void {
  const blocks = document.querySelectorAll<HTMLElement>('.reveal');
  if (!('IntersectionObserver' in window)) {
    blocks.forEach((block) => block.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 },
  );

  blocks.forEach((block) => observer.observe(block));
}

function headerShadow(): void {
  const header = document.querySelector<HTMLElement>('[data-site-header]');
  if (!header) return;

  const update = () => header.classList.toggle('header-scrolled', window.scrollY > 8);
  update();
  window.addEventListener('scroll', update, { passive: true });
}

function mobileMenu(): void {
  const button = document.querySelector<HTMLButtonElement>('[data-menu-button]');
  const menu = document.querySelector<HTMLElement>('[data-menu]');
  if (!button || !menu) return;

  const close = () => {
    menu.hidden = true;
    button.setAttribute('aria-expanded', 'false');
  };

  button.addEventListener('click', () => {
    const open = menu.hidden;
    menu.hidden = !open;
    button.setAttribute('aria-expanded', String(open));
  });
  menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));
}

function currentYear(): void {
  document.querySelectorAll('[data-year]').forEach((node) => {
    node.textContent = String(new Date().getFullYear());
  });
}

revealOnScroll();
headerShadow();
mobileMenu();
currentYear();
